// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__LIS6L","load6":"Spinner_load6__d-cjO","round":"Spinner_round__e7McN"};